import BookAnAppointmentDateSelection from '@moncler/components/appointments/BookAnAppointmentDateSelection';
import BookAnAppointmentReasonMessage from '@moncler/components/appointments/BookAnAppointmentReasonMessage';
import ErrorBox from '@components/common/ErrorBox';
import ErrorModal from '@components/error/ErrorModal';
import ProductAddToBag from '@moncler/components/product/ProductActionAddToBag';
import ProductSelectionFormats from '@moncler/components/product/ProductSelectionFormats';
import StoreAddress from '@components/storelocator/StoreAddress';
import Button from '@ui/button/Button';
import DwFormField from '@ui/formfield/DwFormField';
import DwFormFieldPhoneWithPrefix from '@ui/formfield/DwFormFieldPhoneWithPrefix';
import ModalDialog from '@ui/modal/ModalDialog';
import addressutils from '@utils/addressutils';
import analytics from '@utils/analytics';
import api from '@utils/api';
import { BAA } from '@utils/constants';
import formutils from '@utils/formutils';
import { getColorVariations, getProductMasterId, getSizeVariations } from '@utils/product';
import useBreakpoint from '@utils/useBreakpoint';
import createDecorator from 'final-form-focus';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import ProductImage from '../product/ProductImage';
import ProductSelectionColorExpanded from '../product/ProductSelectionColorExpanded';
import ProductSelectionSizesExpanded from '../product/ProductSelectionSizesExpanded';
import ProductBoutiqueSelected from './ProductBoutiqueSelected';
import ProductBoutiqueTabCountry from '@components/reserve/ProductBoutiqueTabCountry';
import ProductBoutiqueTabEurope from '@components/reserve/ProductBoutiqueTabEurope';
import LoginOrRegisterColumn from '@components/login/LoginOrRegisterColumn';
import useInnerWidth from '@utils/useInnerWidth';
import classNames from 'classnames';
import { debounce } from '@common/utils/functions';
import DigitalFlagshipSmallPromoCard from '../experience/DigitalFlagshipSmallPromoCard';
const focusOnError = createDecorator();
const ProductBoutiqueModal = (props) => {
    var _a, _b, _c, _d;
    const { t } = useTranslation();
    const currentBreakpoint = useBreakpoint();
    const [product, setProduct] = useState(props.product);
    const [currentColor, setCurrentColor] = useState();
    const [currentSize, setCurrentSize] = useState();
    const [loggedIn, setLoggedIn] = useState(window.loggedin);
    const [currentStore, setCurrentStore] = useState();
    const [requestSent, setRequestSent] = useState();
    const [formdef, setFormdef] = useState();
    const [initialValues, setInitialValues] = useState();
    const [countries, setCountries] = useState([]);
    const [errors, setErrors] = useState([]);
    const [days, setDays] = useState({});
    const [localizedProductPrice, setLocalizedProductPrice] = useState('');
    const [collections, setCollections] = useState([]);
    const [errorMessage, setErrorMessage] = useState();
    const [clickAndReserveEnabled, setClickAndReserveEnabled] = useState(false);
    const [loginEmail, setLoginEmail] = useState();
    const [firstName, setFirstName] = useState();
    const [lastName, setLastName] = useState();
    const [phone, setPhone] = useState();
    const [phonePrefix, setPhonePrefix] = useState();
    const [isDesktop, setIsDesktop] = useState(false);
    const currentWidth = useInnerWidth();
    const reserveDetailRef = useRef();
    useEffect(() => {
        if (props.isOpen) {
            api.getBoutiqueCountries().then((data) => {
                setCountries(data);
            });
        }
    }, [props.isOpen]);
    useEffect(() => {
        if (currentBreakpoint >= window.mqObj.md) {
            setIsDesktop(true);
        }
        else {
            setIsDesktop(false);
        }
    }, [currentBreakpoint]);
    useEffect(() => {
        let width = document.querySelector('.store-details');
        if (width || requestSent) {
            let emailInput = document.querySelector('.email');
            if (emailInput) {
                emailInput.style.width = width.offsetWidth + 'px';
            }
        }
    }, [currentWidth, requestSent]);
    useEffect(() => {
        var _a;
        if (isDesktop && reserveDetailRef) {
            // @ts-ignore
            (_a = reserveDetailRef === null || reserveDetailRef === void 0 ? void 0 : reserveDetailRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }, [currentStore, reserveDetailRef]);
    // update internal product to avoid errors
    useEffect(() => {
        var _a;
        setProduct(props.product);
        if ((_a = props.product) === null || _a === void 0 ? void 0 : _a.isParfum) {
            setCurrentColor(getColorVariations(props.product)[0]);
            setCurrentSize(getSizeVariations(props.product)[0]);
        }
    }, [props.product]);
    // non renderizzare la modale all'apertura della pagina, non fare chiamate se non aperta
    const firstRender = useRef(true);
    useEffect(() => {
        if (props.isOpen && firstRender.current) {
            firstRender.current = false;
            api.getClickAndReserveConfig().then((data) => {
                if (data.limitOrdersEnabled) {
                    setClickAndReserveEnabled(true);
                }
            });
        }
        if (props.isOpen && loggedIn) {
            getForm();
        }
    }, [props.isOpen, loggedIn]);
    const getForm = () => {
        let val = {};
        api.getForm('reserve', val).then((data) => {
            setFirstName(data.firstname.htmlValue);
            setLastName(data.lastname.htmlValue);
            setPhone(data.phone.htmlValue);
            setPhonePrefix(data.phonePrefix.htmlValue);
            setLoginEmail(data.email.htmlValue);
            val.applicationorigin = window.appmode ? 'app' : 'web';
            setInitialValues(val);
            setFormdef(data);
            if (!loggedIn) {
                setLoggedIn(true);
            }
        });
    };
    const productSelected = useMemo(() => {
        var _a, _b, _c;
        if (product === null || product === void 0 ? void 0 : product.isParfum) {
            return (_c = (_b = (_a = product.parfumAttributes) === null || _a === void 0 ? void 0 : _a.productFamily) === null || _b === void 0 ? void 0 : _b.find((parfumFormat) => parfumFormat.groupId === product.id)) === null || _c === void 0 ? void 0 : _c.id;
        }
        if (currentColor !== undefined && currentSize !== undefined) {
            return `${currentColor.productId}${currentSize.id}`;
        }
        return;
    }, [product, currentColor, currentSize]);
    const resetOnClose = useCallback(() => {
        props.onRequestClose();
        setTimeout(() => {
            setRequestSent(undefined);
            setCurrentStore(undefined);
        }, 1000);
    }, [props.onRequestClose]);
    const noResults = useMemo(() => {
        return (React.createElement("div", { className: "product-reserve__detail__text", role: "alert", "aria-live": "polite" }, (currentSize === null || currentSize === void 0 ? void 0 : currentSize.selectable) && !(product === null || product === void 0 ? void 0 : product.isBoutiqueExclusive) && !(product === null || product === void 0 ? void 0 : product.notShoppable) ? (React.createElement(React.Fragment, null,
            React.createElement("p", null, t('findinboutique.notavailableinboutique')),
            React.createElement(ProductAddToBag, { product: product, size: currentSize, pushAnalytics: () => {
                    // analytics.quickShopAddToBag(product.masterId, product.type);
                    analytics.quickShopAddToBagDetails(product, currentSize.value);
                }, callback: resetOnClose, updateErrorMessage: (msg) => setErrorMessage(msg) }),
            React.createElement(ErrorModal, { message: errorMessage, onClose: () => setErrorMessage(undefined) }))) : (React.createElement(React.Fragment, null,
            React.createElement("p", null, t('findinboutique.notavailable')),
            React.createElement(Button, { type: "button", onClick: () => props.onRequestClose() }, t('button.backtoshopping'))))));
    }, [currentSize, product, errorMessage]);
    useEffect(() => {
        // Update the current size when it changes from outside.
        if (props === null || props === void 0 ? void 0 : props.size) {
            if (product) {
                let sizeVariation = getSizeVariations(product).find((s) => s.id == props.size.id);
                setCurrentSize(sizeVariation);
            }
            else {
                setCurrentSize(props.size);
            }
        }
    }, [props === null || props === void 0 ? void 0 : props.size]);
    useEffect(() => {
        // Update the current color when it changes from outside.
        if (props === null || props === void 0 ? void 0 : props.color) {
            setCurrentColor(props.color);
        }
    }, [props === null || props === void 0 ? void 0 : props.color]);
    const prefillValues = (values) => {
        values.productid = `${currentColor.productId}${currentSize.id}`;
        values.storeid = currentStore.ID;
    };
    useEffect(() => {
        var _a, _b, _c;
        if (currentStore) {
            analytics.reserveInBoutiqueOverlay(product.id, currentSize.id);
        }
        if (currentStore && ((_a = currentStore === null || currentStore === void 0 ? void 0 : currentStore.storeServices) === null || _a === void 0 ? void 0 : _a.bookAnAppointment)) {
            api.bookAnAppointmentSlots(currentStore === null || currentStore === void 0 ? void 0 : currentStore.ID, undefined, true).then((data) => {
                setDays(data.days);
            });
            api.bookAnAppointmentCollections(currentStore === null || currentStore === void 0 ? void 0 : currentStore.ID).then((data) => {
                setCollections(data);
            });
        }
        else {
            setDays({});
        }
        if (!currentStore) {
            try {
                (_c = (_b = document === null || document === void 0 ? void 0 : document.querySelector('.product-reserve__detail')) === null || _b === void 0 ? void 0 : _b.classList) === null || _c === void 0 ? void 0 : _c.remove('zoom-product');
            }
            catch (error) {
                console.log(error);
            }
        }
    }, [currentStore]);
    const validate = async (values) => {
        if (window.loggedin) {
            values.privacyFlag = true;
        }
        prefillValues(values);
        return await formutils.validateForm(values, formdef, 'reserve');
    };
    const onSubmit = async (values) => {
        setErrors([]);
        let err = await validate(values);
        if (err && Object.keys(err).length > 0) {
            return err;
        }
        return await api
            .reserveInBoutique(values, formdef)
            .then((data) => {
            var _a, _b, _c;
            let errors = {};
            if (!data || data.error || ((_a = data.error) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                setErrors(((_b = data.error) === null || _b === void 0 ? void 0 : _b.length) > 0 ? data.error : data.serverErrors.slice(0, 1));
                console.error(((_c = data.error) === null || _c === void 0 ? void 0 : _c.length) > 0 ? data.error : data.serverErrors);
                return;
            }
            if (!formutils.checkValidationAfterSubmit(data, errors)) {
                return errors;
            }
            setLocalizedProductPrice(data.localizedPrice);
            props.mode === 'find' ? analytics.findInBoutiqueSubmit(product.id) : analytics.reserveInBoutiqueSubmit(product.id, currentSize.id, product.analyticsAttributes.dimension14);
            setRequestSent(values);
        })
            .catch((e) => console.error(e));
    };
    const setSizeCallback = (val) => {
        setCurrentSize(val);
        props.mode === 'find' ? analytics.findInBoutiqueSelectedSize(val.displayValue, product.masterId) : analytics.reserveInBoutiqueSelectedSize(val.displayValue, product.masterId);
    };
    const setColorCallback = (colorVariation) => {
        if (!colorVariation) {
            return;
        }
        setCurrentColor(colorVariation);
        api.getProductTile(getProductMasterId(product) + colorVariation.id).then((data) => {
            if (!!data) {
                setProduct(data);
                let sizeVariation = getSizeVariations(data).find((s) => s.id == currentSize.id);
                setCurrentSize(sizeVariation);
            }
        });
    };
    const updateParfumProduct = (selectedItem) => {
        if (!selectedItem) {
            return;
        }
        api.getProductTile(selectedItem.groupId).then((data) => {
            if (!!data) {
                setProduct(data);
                setCurrentColor(getColorVariations(data)[0]);
                let selectedSize = getSizeVariations(data)[0];
                setCurrentSize(selectedSize);
                props.mode === 'find'
                    ? analytics.findInBoutiqueSelectedSize(selectedSize.displayValue, product.masterId)
                    : analytics.reserveInBoutiqueSelectedSize(selectedSize.displayValue, product.masterId);
            }
        });
    };
    const storeChooser = useCallback(() => {
        var _a, _b;
        return countries.length > 0 ? (React.createElement(Tabs, { className: "tabs tabs--fluid tabs--capitalize" },
            React.createElement(TabList, { className: "container react-tabs__tab-list" },
                countries.find((c) => c.selected) && React.createElement(Tab, null, countries.find((c) => c.selected).label),
                window.site === 'MonclerEU' && React.createElement(Tab, null, t('label.europe'))),
            countries.find((c) => c.selected) && (React.createElement(TabPanel, null, productSelected ? (React.createElement(ProductBoutiqueTabCountry, { pid: productSelected, country: (_a = countries.find((c) => c.selected)) === null || _a === void 0 ? void 0 : _a.value, noResults: noResults, onStoreSelect: setCurrentStore })) : (React.createElement("div", { className: "product-reserve__detail__text" },
                React.createElement("p", null, t('findinboutique.selectsize')))))),
            window.site === 'MonclerEU' && (React.createElement(TabPanel, null, productSelected ? (React.createElement(ProductBoutiqueTabEurope, { pid: productSelected, country: (_b = countries.find((c) => c.selected)) === null || _b === void 0 ? void 0 : _b.value, noResults: noResults, onStoreSelect: setCurrentStore })) : (React.createElement("div", { className: "product-reserve__detail__text" },
                React.createElement("p", null, t('findinboutique.selectsize')))))))) : (React.createElement(React.Fragment, null));
    }, [productSelected, countries, errorMessage, noResults]);
    const info = (React.createElement("div", { className: "product-reserve-review" },
        React.createElement("p", { className: "bold mb-4 primary-s" }, product === null || product === void 0 ? void 0 : product.productName),
        (product === null || product === void 0 ? void 0 : product.isParfum) ? (React.createElement("p", { className: "option-product__size" },
            t('label.format'),
            " ", (_c = (_b = (_a = product === null || product === void 0 ? void 0 : product.parfumAttributes) === null || _a === void 0 ? void 0 : _a.productFamily) === null || _b === void 0 ? void 0 : _b.find((el) => el.groupId == product.id)) === null || _c === void 0 ? void 0 :
            _c.format)) : (React.createElement(React.Fragment, null,
            React.createElement("p", { className: "mb-4 wrapper-color" },
                t('findinboutique.color', { color: currentColor === null || currentColor === void 0 ? void 0 : currentColor.displayValue }),
                (currentColor === null || currentColor === void 0 ? void 0 : currentColor.swatchColor) && (React.createElement("span", { style: {
                        background: currentColor === null || currentColor === void 0 ? void 0 : currentColor.swatchColor,
                        height: '7px',
                        width: '7px',
                    } }))),
            React.createElement("p", null, t('findinboutique.size', { size: currentSize === null || currentSize === void 0 ? void 0 : currentSize.displayValue }))))));
    const review = useCallback(() => {
        var _a, _b, _c, _d;
        return (React.createElement("div", { className: "product-reserve__detail__reserve-review" },
            React.createElement("h2", { className: "primary-m", role: "alert" }, t('notifyme.thankyou', { title: formutils.labelByValue(requestSent.title, formdef.title), name: requestSent.firstname, surname: requestSent === null || requestSent === void 0 ? void 0 : requestSent.lastname })),
            React.createElement("p", { className: "mt-12" }, t('findinboutique.confirmation')),
            React.createElement("div", { className: "product-reserve__detail__review" },
                !isDesktop && React.createElement("div", { className: "product-reserve__detail__review-divider" }),
                React.createElement("div", { className: "product-reserve__detail__review-grid" },
                    !isDesktop && (React.createElement(React.Fragment, null,
                        React.createElement("div", { className: "product-reserve__detail__review-product" },
                            React.createElement("p", { className: "primary-xxs-u mb-4" }, product === null || product === void 0 ? void 0 : product.productName),
                            (product === null || product === void 0 ? void 0 : product.isParfum) ? (React.createElement("p", { className: "option-product__size" },
                                t('label.format'),
                                " ", (_b = (_a = product === null || product === void 0 ? void 0 : product.parfumAttributes) === null || _a === void 0 ? void 0 : _a.productFamily) === null || _b === void 0 ? void 0 :
                                _b.find((el) => el.groupId == product.id).format)) : (React.createElement(React.Fragment, null,
                                React.createElement("p", { className: "mb-4 wrapper-color" },
                                    t('findinboutique.color', { color: currentColor === null || currentColor === void 0 ? void 0 : currentColor.displayValue }),
                                    (currentColor === null || currentColor === void 0 ? void 0 : currentColor.swatchColor) && (React.createElement("span", { style: {
                                            background: currentColor === null || currentColor === void 0 ? void 0 : currentColor.swatchColor,
                                            height: '7px',
                                            width: '7px',
                                            border: '1px solid',
                                        } }))),
                                React.createElement("p", null, t('findinboutique.size', { size: currentSize.displayValue }))))))),
                    React.createElement("div", { className: "product-reserve__detail__review-divider" }),
                    React.createElement("div", { className: "product-reserve__detail__review-store" },
                        React.createElement("p", { className: "product-reserve__detail__review-header primary-xs" }, t('findinboutique.storeinfo')),
                        React.createElement(StoreAddress, { store: currentStore, showphone: true, showmail: true })),
                    React.createElement("div", { className: "product-reserve__detail__review-customer" },
                        React.createElement("p", { className: "product-reserve__detail__review-header primary-xs" }, t('findinboutique.customerinfo')),
                        React.createElement("p", null,
                            React.createElement("span", { className: "product-reserve__detail__review-content" }, addressutils.salutation(requestSent.firstname, requestSent.lastname, formutils.labelByValue(requestSent === null || requestSent === void 0 ? void 0 : requestSent.title, formdef === null || formdef === void 0 ? void 0 : formdef.title))),
                            React.createElement("span", { className: "product-reserve__detail__review-content" }, requestSent.email),
                            React.createElement("span", { className: "product-reserve__detail__review-content" },
                                requestSent.phonePrefix,
                                " ",
                                requestSent.phone)),
                        (requestSent === null || requestSent === void 0 ? void 0 : requestSent.message) && (React.createElement(React.Fragment, null,
                            React.createElement("p", { className: "product-reserve__detail__review-header primary-xs boutique-message" }, t('findinboutique.message')),
                            React.createElement("p", null,
                                React.createElement("span", { className: "product-reserve__detail__review-content" }, requestSent.message)))))),
                currentStore.interactiveStoreModule && (React.createElement("div", { className: "digital-flaship-promocard" },
                    React.createElement(DigitalFlagshipSmallPromoCard, { store: currentStore }))),
                requestSent.bookanappointment && (requestSent === null || requestSent === void 0 ? void 0 : requestSent.date) && (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "product-reserve__detail__review-divider booked-appointment" }),
                    React.createElement("div", { className: "product-reserve__detail__review-store" },
                        React.createElement("p", { className: "product-reserve__detail__review-header primary-xs" }, t('bookanappointment.appointmentdetails')),
                        React.createElement("span", { className: "product-reserve__detail__review-content" },
                            t('label.date'),
                            ": ", requestSent === null || requestSent === void 0 ? void 0 :
                            requestSent.date),
                        React.createElement("span", { className: "product-reserve__detail__review-content" },
                            t('label.hour'),
                            ": ", (_d = (_c = days[requestSent === null || requestSent === void 0 ? void 0 : requestSent.date]) === null || _c === void 0 ? void 0 : _c.find((p) => (p === null || p === void 0 ? void 0 : p.value) == requestSent.hour)) === null || _d === void 0 ? void 0 :
                            _d.label))))),
            React.createElement("div", { className: "product-reserve__detail__review-divider booked-appointment" }),
            React.createElement(Button, { type: "button", onClick: () => props.onRequestClose() }, t('button.backtoshopping'))));
    }, [product, requestSent]);
    const toogleChecked = (e) => {
        const checked = e.currentTarget.checked;
        if (!checked) {
            document.querySelector('.wrapper-bookanappointment').classList.add('d-none');
        }
        else {
            document.querySelector('.wrapper-bookanappointment').classList.remove('d-none');
        }
    };
    const reserveForm = useCallback(() => {
        var _a;
        return (React.createElement("div", null,
            React.createElement(ProductBoutiqueSelected, { store: currentStore, onArrowBack: () => setCurrentStore(null), withBorder: true }),
            React.createElement("div", { className: "product-reserve__detail__form" },
                React.createElement(Form, { initialValues: initialValues, onSubmit: onSubmit, validate: validate, decorators: [focusOnError], mutators: {
                        global: formutils.globalMutator,
                        resetHours: (args, state, utils) => {
                            utils.changeValue(state, 'hour', () => null);
                        },
                    }, render: ({ handleSubmit, form, submitting, pristine, values }) => {
                        var _a;
                        return (React.createElement("form", { onSubmit: handleSubmit },
                            React.createElement("fieldset", { className: "fieldset--plain" },
                                React.createElement("div", { className: "ReserveForm" },
                                    React.createElement("div", { className: "wrapper-info mt-16" },
                                        React.createElement("div", { className: "row mb-20" },
                                            React.createElement("span", { className: "primary-xs-u col-12 mb-8" }, t('profile.namesurname')),
                                            React.createElement("span", { className: "bold col-12" },
                                                firstName,
                                                " ",
                                                lastName)),
                                        React.createElement("div", { className: "row mb-20" },
                                            React.createElement("span", { className: "primary-xs-u col-12 mb-8" }, t('profile.email')),
                                            React.createElement("span", { className: "bold col-12" }, loginEmail)),
                                        phone && (React.createElement("div", { className: "row mb-20" },
                                            React.createElement("span", { className: "primary-xs-u col-12 mb-8" }, t('profile.phonenumber')),
                                            React.createElement("span", { className: "bold col-12" },
                                                phonePrefix,
                                                " ",
                                                phone))),
                                        !phone && (React.createElement(React.Fragment, null,
                                            React.createElement("div", { className: "mb-12" },
                                                React.createElement("span", null, t('profile.additionalinfo'))),
                                            React.createElement(DwFormFieldPhoneWithPrefix, { def: formdef, uniqueLabel: t('profile.phonenumber') })))),
                                    React.createElement("div", { className: "row" },
                                        React.createElement("div", { className: "col-12" },
                                            React.createElement(DwFormField, { def: formdef, name: "message", type: "textarea" }))),
                                    React.createElement("div", { className: "row" },
                                        React.createElement("div", { className: "col-12" },
                                            React.createElement(DwFormField, { def: formdef, name: "applicationorigin", value: values.applicationorigin, hiddenLabel: true, className: "visually-hidden" }))),
                                    ((_a = currentStore === null || currentStore === void 0 ? void 0 : currentStore.storeServices) === null || _a === void 0 ? void 0 : _a.bookAnAppointment) && Object.keys(days).length > 0 && (React.createElement(React.Fragment, null,
                                        React.createElement("p", { className: "bold primary-xxs" }, t('bookanappointment.text')),
                                        React.createElement("div", { className: "checkbox" },
                                            React.createElement("div", { className: "checkbox__field" },
                                                React.createElement("input", { type: "checkbox", id: "bookanappointment", defaultChecked: false, onChange: (e) => {
                                                        toogleChecked(e);
                                                        form.mutators.global({ bookanappointment: e.currentTarget.checked });
                                                    } }),
                                                React.createElement("label", { htmlFor: "bookanappointment" }, t('bookanappointment.checkbox')))),
                                        React.createElement("div", { className: "wrapper-bookanappointment mt-20 d-none" },
                                            React.createElement(BookAnAppointmentDateSelection, { formdef: formdef, days: days, values: values, form: form }),
                                            React.createElement("div", { className: "row" },
                                                React.createElement("div", { className: values.reason == BAA.REASONS.DISCOVERCOLLECTION ? 'col-lg-6' : 'col-12' },
                                                    React.createElement(DwFormField, { requiredLabel: true, def: formdef, name: "reason", type: "select" })),
                                                values.reason == BAA.REASONS.DISCOVERCOLLECTION && (collections === null || collections === void 0 ? void 0 : collections.length) > 0 && (React.createElement("div", { className: "col-12 col-lg-6" },
                                                    React.createElement(DwFormField, { def: formdef, name: "collectionCode", type: "select", options: [{ value: '', label: t('label.select') }].concat(collections) || [] })))),
                                            React.createElement(BookAnAppointmentReasonMessage, { formdef: formdef, values: values }),
                                            React.createElement("div", { className: "appointments-mandatoryField mb-20" }, t('label.mandatoryfields')))))),
                                React.createElement("div", { className: "disclaimer" }, t('findinboutique.disclaimer'))),
                            React.createElement("div", { className: "product-reserve__detail__form__submit" },
                                React.createElement(Button, { type: "submit", disabled: submitting, cls: ['button--primary'] }, t('button.reserveitem')))));
                    } }),
                React.createElement(ErrorBox, { errors: errors }),
                React.createElement("p", { className: "product-reserve__detail__form__note" },
                    React.createElement("small", { className: "note", dangerouslySetInnerHTML: { __html: t('notifyme.termsandconditions', { 0: (_a = document.getElementById('hidden-cookieurl')) === null || _a === void 0 ? void 0 : _a.href }) } })))));
    }, [currentStore, formdef, days, collections, errors]);
    // TODO rimuovere questa roba inutile
    const onSizeSelection = (size) => {
        console.info('size: ' + size);
        /* if (size) {
          let sizeVariation: models.VariationValue = sizeVariations.find((s) => s.id == size);
          if (sizeVariation) {
            changeSize(sizeVariation);
          }
        } */
    };
    const content = () => {
        if (!currentStore) {
            // step 0
            return storeChooser();
        }
        else if (requestSent && loggedIn) {
            // step 2
            if (currentBreakpoint < window.mqObj['md']) {
                return (React.createElement(ModalDialog, { isOpen: true, className: "reserve-form-modal", onRequestClose: resetOnClose, contentLabel: t('product.reserveinboutique') }, review()));
            }
            return review();
        }
        else if (loggedIn) {
            return reserveForm();
        }
        else {
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "divider" }),
                React.createElement(LoginOrRegisterColumn, { privacypolicy: props.privacypolicy, updateLoggeedStatus: () => getForm(), updateLoggedin: () => getForm(), forgotpasswordform: props.forgotpasswordform, closeModal: () => props.onRequestClose, reloadComponent: true, reloadPage: true, reloadRegisterComponent: true, pageContext: "clickandreserve" })));
        }
    };
    // if (!props.isOpen) {
    //   return <></>;
    // }
    const sizeVariations = useMemo(() => {
        let sizeVariations = getSizeVariations(product);
        if (sizeVariations.length == 1) {
            setCurrentSize(sizeVariations[0]);
        }
        else if (!sizeVariations.find((el) => el.id == (currentSize === null || currentSize === void 0 ? void 0 : currentSize.id))) {
            setCurrentSize(undefined);
        }
        return sizeVariations;
    }, [product]);
    const handleResize = debounce((entries) => {
        const el = entries[0].target;
        const scrollbarWidth = el.offsetWidth - el.clientWidth;
        const modal = document.getElementById('reserveinboutique');
        if (modal) {
            modal.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
        }
    }, 200);
    const observer = new ResizeObserver(handleResize);
    return (React.createElement(ModalDialog, { hideHeader: true, noPadding: true, closeInvertedSm: !window.enableColorBackgroundStillLife, isOpen: props.isOpen, className: classNames('reserveinboutique', { 'white-bg': window.enableColorBackgroundStillLife }), onRequestClose: () => {
            resetOnClose();
            observer.unobserve(reserveDetailRef === null || reserveDetailRef === void 0 ? void 0 : reserveDetailRef.current);
        }, contentLabel: props.title, id: "reserveinboutique", onAfterOpen: () => {
            if (reserveDetailRef.current) {
                observer.observe(reserveDetailRef.current);
            }
        } },
        React.createElement("div", { className: "product-reserve" },
            React.createElement("div", { className: classNames('product-reserve__main', { 'zoom-product': currentStore }, { 'is-login': !loggedIn }) },
                React.createElement("h1", { className: "dialog__title d-md-none" }, props.title),
                !requestSent && React.createElement("p", { className: "product-reserve__main__name" }, product === null || product === void 0 ? void 0 : product.productName),
                React.createElement(ProductImage, { img: product === null || product === void 0 ? void 0 : product.imgs, type: "F", nextImages: Object.assign({}, product === null || product === void 0 ? void 0 : product.nextImages) }),
                !requestSent && (React.createElement("div", { className: "product-reserve__main__wrapper" }, (product === null || product === void 0 ? void 0 : product.isParfum) ? (React.createElement(ProductSelectionFormats, { productFormats: (_d = product.parfumAttributes) === null || _d === void 0 ? void 0 : _d.productFamily, currentId: product.id, onChangeFormat: updateParfumProduct, className: props.product.imageBackground !== 'white' ? 'inverted' : '', alwaysAvailable: true, inReserve: true })) : (React.createElement(React.Fragment, null,
                    React.createElement(ProductSelectionColorExpanded, { currentId: currentColor === null || currentColor === void 0 ? void 0 : currentColor.id, variationValues: props.colourVariations, onChangeVariation: setColorCallback, className: classNames('bottom-divider', { inverted: !window.enableColorBackgroundStillLife }), hideOnlineExclusive: true, alwaysAvailable: true }),
                    React.createElement(ProductSelectionSizesExpanded, { current: product, currentId: currentSize === null || currentSize === void 0 ? void 0 : currentSize.id, variationValues: sizeVariations, onChangeVariation: setSizeCallback, className: window.enableColorBackgroundStillLife ? '' : 'inverted', onSizeSelection: onSizeSelection, trackOpenSize: () => (props.mode === 'find' ? analytics.findInBoutiqueOpenSize(product === null || product === void 0 ? void 0 : product.masterId) : analytics.reserveInBoutiqueOpenSize(product.masterId)), hideSizeGuide: true, alwaysAvailable: true, showSizeFit: true }))))),
                info),
            React.createElement("div", { className: "product-reserve__detail", ref: reserveDetailRef },
                React.createElement("h1", { className: "dialog__title" }, props.title),
                clickAndReserveEnabled && (!window.loggedin || !currentStore) && React.createElement("p", { className: "dialog_subtitle" }, t('findinboutique.introduction')),
                " ",
                React.createElement(React.Fragment, null, content())))));
};
export default ProductBoutiqueModal;
